<template >
    
  <v-app style='background-color: #f8f8f8;'>
    <div style="width: 100%; height: 100%; position: absolute; top:50; left:0;">
      <vue-particles
        color='#65d1ea'
        :particleOpacity="0.7"
        :particlesNumber="150"
        shapeType="circle"
        :particleSize="4"
        linesColor='#65d1ea'
        :linesWidth="2"
        :lineLinked="true"
        :lineOpacity="0.3"
        :linesDistance="120"
        :moveSpeed="2"
        :hoverEffect="true"
        hoverMode="grab"
        :clickEffect="true"
        clickMode="push"
      >
      </vue-particles>
    </div>
<!-- #4dbee1 77, 190, 225-->
    <Header/>
    <div>
      <v-container class="grey lighten-5" style="margin-top: 75px!important; max-width: 1200px!important">
            <div>
              <v-img
                :src="logo"
                class="logo"
                style=" max-width: 850px !important;"
              ></v-img>
            </div>


            <div>
              <router-view/>
            </div>
      </v-container>
    </div>
    <v-dialog v-model="GETTERS_OVERLAY">
        <v-overlay :value="GETTERS_OVERLAY"> 
            <v-progress-circular
                size="64"
                indeterminate
                color="grey"
            ></v-progress-circular>
        </v-overlay>
    </v-dialog>
  </v-app>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import Header from './components/Common/Header.vue'
import axios from 'axios';
import { AUTH_URL, REFERENCES_URL } from '../vars';
import user from '../src/assets/user.png';
import logo from '../src/assets/genom_4.png';


export default {
  name: 'App',
  components: {
    Header,
  },
  data() {
    return {
      archive: '',
      logo,

    }
  },
  beforeMount() {
    if (this.GETTERS_TOKEN === null && localStorage.getItem('token')) {
      this.getDataServicesStart()
    }
    // this.$i18n.locale = 'ru'

    // console.log('BEFOREE', this.$route)
  },
  methods: {
    ...mapActions([
      'logged', 
      'GET_PROFILE',
    ]),
    ...mapMutations([
      'UPDATE_USER',
      'UPDATE_AVATAR',
      'UPDATE_NAME_USER',
    ]),

    choose_tab(tab_name){
      switch(tab_name){
        
        case 'personal-data':
          if(localStorage.isLoggedIn)
            this.$router.push('/personal-data')
          else
            this.$router.push('/login')
          break;
        case 'home':
          this.$router.push('/')
          break;
        case 'orgs':
          this.$router.push('/orgs')
          break;
        case 'program':
          this.$router.push('/program')
          break;
        case 'users':
          this.$router.push('/users-list')
          break;
        default:
          break;
      }
    },

    async getDataServicesStart(val) {
      try {
        
          await this.logged({ token: val });
          await this.GET_PROFILE(localStorage.isLoggedIn)  
          await this.UPDATE_NAME_USER(this.GETTERS_PROFILE.data.profiles[0].individual.last_name + ' ' + this.GETTERS_PROFILE.data.profiles[0].individual.first_name)
          await this.UPDATE_USER(this.GETTERS_PROFILE.data.profiles[0])
          await this.UPDATE_AVATAR(this.GETTERS_PROFILE.data)        


      } catch (ex) {
        console.log('APP ', ex);
      }
    },

  },
  computed: {
    ...mapGetters(['GETTERS_LOGIN', 'GETTERS_PROFILE', 'GETTERS_TOKEN', 'GETTERS_OVERLAY'])
  },
  watch: {
    GETTERS_TOKEN(val) {
      localStorage.setItem('token', val)

      this.getDataServicesStart(val)
    },
    GETTERS_PROFILE(val) {
      // this.archive = val.data.profiles[0].individual.attached_old_proposals
      // if (val.data.profiles[0].individual.update_personal_data ){
      //   if (this.$route.path != '/personal-data') location.href = '/personal-data'
      // }
    },
    $route (to, from){
      // console.log('APP', to.path)
    },
  }
};
</script>

<style>
  .main-body-1 {
    max-width: 1600px;
    margin-left: auto;
    margin-right: auto;
    min-width: 1024px;
    margin-top: 75px;
  }

  .main-body {
    min-width: 720px;
    max-width: 1200px;
    /* width: 100%; */
    height: 100%;
    /* position: fixed; */
    top: 0;
    left: 0;
    display: flex;
    /* align-items: center; */
    padding-top: 70px;
    align-content: center;
    justify-content: center;
    overflow: auto;
  }
</style>

<style lang="scss">

  $success-toast-color: #4CAF50;
  $error-toast-color: #FF5252;
  $warning-toast-color: #FFC107;
  $default-toast-color: grey;

  *, body, html {
    font-family: "Montserrat", sans-serif;
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    
  }
  .main-container{
    margin-right: 55px !important;
    margin-bottom: 60px !important;
    margin-left: 5px !important;
    border-radius: 13px!important;

  }
  .p-l-15 {
    padding-left: 15px;
  } 
  .p-r-15 {
    padding-right: 15px;
  }
  .switch-login {
    position: absolute;
    top: 25px;
    left: 54%;
  }
  .switch{
    margin-top: 0;
    margin-left:10px;

    .v-input--selection-controls {
        margin-top: 0 !important;
    }
  }

  .switch__current-lang {
    padding-top:3px;
    font-size: 16px;
    margin-right: 10px;
    color: rgba(0, 0, 0, 0.6);
  }

  .help-name-page {
    position: absolute;
    top: 6%;
    right: 10px;
    color: #4dbee1;
    z-index: 1;
  }
  .mb-12.wrapper.v-card.v-sheet.theme--light.white{
    box-shadow: none;
  }
  .v-stepper__header{
    box-shadow: none;
  }
  .theme--light.v-stepper.v-stepper__header.v-divider{
    background-color: #4dbee1;
  }
  .v-application .primary{
    background-color: #4dbee1 !important;
  }
  *, body, html{
    box-shadow: none;
  }
  .v-stepper.header-stepper.theme--light{
    box-shadow: none;
  }
  .v-application--is-ltr .v-stepper__label {
    text-align: center !important;
  }
  .Vue-Toastification__toast {
    min-height: 54px !important;
    padding: 16px 24px !important;
    background: white !important;
  }

  .Vue-Toastification__toast--warning,
  .Vue-Toastification__close-button {
    color: $warning-toast-color !important;
  }
  .Vue-Toastification__toast--success,
  .Vue-Toastification__close-button {
    color: $success-toast-color !important;
  }
  .Vue-Toastification__toast--error,
  .Vue-Toastification__close-button {
    color: $error-toast-color !important;
  }
  .Vue-Toastification__toast--info,
  .Vue-Toastification__close-button {
    color: $default-toast-color !important;
  }
  .error-input {
    border: 2px solid #ff5252 !important;
    color: #ff5252;
  }
</style>
